<template>
  <v-card
    outlined
    width="100%"
    class="mb-5"
  >
    <v-card-text>
      <v-row align="center">
        <v-col>
          <h2 class="text-h5 font-weight-light mb-2 mt-">
            Edistyminen
          </h2>
          <v-progress-linear
            v-if="body.tradePhase !== 'CANCELLED'"
            v-model="progress"
            buffer-value="0"
            color="blue"
            stream
            class="mb-1 mt-2"
          />
          <p class="mt-1 helmi-font text-left mt-2 mb-0">
            Tila: <span class="font-weight-medium">{{ latestStatus }}</span>
          </p>
        </v-col>
        <v-btn
          v-if="body.tradePhase"
          icon
          class="mr-4"
          color="primary"
          @click="refresh()"
        >
          <v-icon>cached</v-icon>
        </v-btn>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    body: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    progress() {
      const percentages = {
        DRAFT: 15,
        SUBMITTED_FOR_APPROVALS: 25,
        BUYER_BANK_APPROVED: 30,
        SELLER_BANK_APPROVED: 35,
        APPROVAL_PHASES_COMPLETED: 40,
        INITIATOR_CONFIRMED_START_SIGNING: 45,
        SIGNERS_INVITED_TO_SIGN_1: 50,
        SIGNING_1_COMPLETED: 55,
        SIGNERS_INVITED_TO_SIGN_2: 60,
        SIGNING_2_COMPLETED: 65,
        BUYER_BANK_PAID_TO_SELLER_BANK: 70,
        BUYER_BANK_PAID_TRANSFER_TAXES: 75,
        SELLER_BANK_PAID_TO_SELLER: 80,
        SELLER_BANK_PAID_REALTOR_COMMISSION: 85,
        PANTTIKIRJAN_SIIRTOHAKEMUS_SKIPPED_OR_APPROVED: 90,
        LAINHUUTO_RATKAISTU: 95,
        COMPLETED: 100,
        MOVED_TO_MANUAL_PROCESSING: 0,
        CANCELLED: 0,
      };

      return percentages[this.body.tradePhase] || 0;
    },

    latestStatus() {
      if (!this.body?.events) return '';
      return this.body.events[this.body.events.length - 1].displayText.fin;
    },
  },

  methods: {
    refresh() {
      this.$bus.$emit('REFRESH_SALE_DATA');
    },
  },
};
</script>
